module.exports = __webpack_public_path__ + "img/加藤.ff270c27.jpg";